import { useSelection } from '@components/ArtBoard/Node/hooks'
import useBlocks from '@components/ArtBoard/Search/selectors/useBlocks'
import { CanvasActionTypes } from '@storeOld/reducers/canvas/canvas'
import { showComments } from '@storeOld/reducers/comments'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { openBlock } from '@storeOld/reducers/ui'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { GlobalActions } from '@/store'
import type { Comment, StickyNote } from '@/types'
import { SearchEntity } from './useSearch'

export const useOnSelect = () => {
  const dispatch = useDispatch()
  const blocks = useBlocks()
  const selection = useSelection()

  const jumpOrPromptUncollapse = useCallback((id: string, cb: () => void) => {
    if (document.querySelector(`[id="${id}"]`)) {
      cb()
      return
    }

    dispatch(
      notificationActionCreators.setNotification({
        type: NotificationType.TARGET_PAGE_COLLAPSED,
        callback: () => {
          // todo implement action
          // dispatch(withSaving(uncollapseNodeParents(id)))
          setTimeout(cb)
        },
      })
    )
  }, [])

  return (entity: SearchEntity, payload: any) => {
    switch (entity) {
      case SearchEntity.BLOCK: {
        // @TODO review this and fix
        // @ts-expect-error - Cannot find name 'BlockItem'
        const block = payload as BlockItem

        jumpOrPromptUncollapse(block.nodeId, () => {
          dispatch(
            GlobalActions.jumpTo({
              selector: 'id',
              value: block.nodeId,
            })
          )

          dispatch({
            type: CanvasActionTypes.SELECT_BLOCK,
            payload: block.id,
          })
        })
        return
      }

      case SearchEntity.PAGE: {
        // @TODO review this and fix
        // @ts-expect-error - Cannot find name 'BlockItem'
        const node = payload as BlockItem

        jumpOrPromptUncollapse(node.id, () => {
          dispatch(
            GlobalActions.jumpTo({
              selector: 'id',
              value: node.id,
            })
          )

          selection.clearSelectionForOthers(node.id)
        })
        return
      }

      case SearchEntity.BLOCK_NOTE: {
        // @TODO review this and fix
        // @ts-expect-error - Cannot find name 'BlockItem'
        const block = payload as BlockItem

        jumpOrPromptUncollapse(block.nodeId, () => {
          dispatch(
            openBlock({
              id: block.id,
            })
          )

          dispatch(
            GlobalActions.jumpTo({
              selector: 'id',
              value: block.nodeId,
            })
          )

          const element = document.querySelector(
            `#${block.id} .Block-content`
          ) as HTMLElement
          element?.click()
        })
        return
      }

      case SearchEntity.NOTE: {
        const node = payload as StickyNote

        // a note hanging on a page is not drawn while the page is collapsed
        // away, and says so the way a comment on such a page does (OCT-5256)
        jumpOrPromptUncollapse(node.id, () => {
          dispatch(
            GlobalActions.jumpTo({
              selector: 'id',
              value: node.id,
            })
          )

          const event = new MouseEvent('mouseup', {
            view: window,
            cancelable: true,
            bubbles: true,
          })

          document.getElementById(node.id)?.dispatchEvent(event)
        })
        return
      }

      case SearchEntity.COMMENT: {
        const comment = payload as Comment

        if (comment.commentableType === 1) {
          jumpOrPromptUncollapse(comment.commentable, () => {
            // @TODO review this and fix
            // @TODO review this and fix
            dispatch(
              GlobalActions.jumpTo({
                value: comment.commentable,
                selector: 'id',
              })
            )
            // @TODO review this and fix
            // @ts-expect-error - Argument of type '(dispatch: any, getState: any) => void' is not assignable to parameter of type 'UnknownAction'
            dispatch(showComments(comment.commentable))
          })
          return
        }

        if (comment.commentableType === 2) {
          const block = blocks.find((block) => block.id === comment.commentable)

          if (block) {
            // @TODO review this and fix
            // @ts-expect-error - string | undefined is not assignable to string
            jumpOrPromptUncollapse(block.nodeId, () => {
              // @TODO review this and fix
              dispatch(
                // @ts-expect-error - string | undefined is not assignable to string
                GlobalActions.jumpTo({ value: block.nodeId, selector: 'id' })
              )

              dispatch(
                // @todo implement action
                openBlock({
                  id: block.id,
                })
              )
            })
          }
        }

        break
      }
      default:
    }
  }
}
